import React from 'react'
import styled from 'styled-components'

export const Dot = styled.div`
  background-color: ${({color}) => color};
  height: 6px;
  width: 6px;
  border-radius: 50%;

  &.abs {
    position: absolute;
    top: 50%;
    left: -1px;
    transform: translate(-100%, -50%);
  }
`

export const Dots = styled.div`
  height: 1px;
  flex: 1;
  border-bottom: 1px dotted #272727;
`

export const Footer1 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div.value {
    padding: .2rem .4rem;
    background-color: white;
  }
`

export const Footer2 = styled.div`
  display: grid;
  grid-template-columns: 6px 1fr 1fr 1fr 1fr 6px;
  gap: 12px;

  position: relative;

  margin-top: 10px;
  &.first {
    margin-bottom: 18px;
  }
`

const Card = styled.div`
  flex: 1;

  min-width: 208px;

  padding: 32px 20px 20px;
  border-radius: 16px;
  background-color: #F0F0F0;
  color: #272727;
  font-size: 14px;
  font-weight: 500;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &.number div.br {
    height: 20px;
  }

  &.number p.value {
    font-size: 30px;
  }
  &.number p.more {
    color: #27272777;
  }

  &.chart > div.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  & div.row-bars {
    flex: 1;

    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }
`

export const ValueBlock = ({title, value, details, comments}:{
  title: string;
  value: string;
  details?: string;
  comments?: string;
}) => {
  return (
    <Card className='number'>
      <p className='title'>{title}</p>
      <div>
        <p className='value'>{value}</p>
        <div className='br' />
        <p className='more'>{details || ''}&nbsp;</p>
        <p className='more'>{comments || ''}&nbsp;</p>
      </div>
    </Card>
  )
}

export const Chart = ({title, legend, chart, footer}:{
  title: string;
  legend: React.ReactNode;
  chart: React.ReactNode;
  footer: React.ReactNode;
}) => {
  return (
    <Card className='chart'>
      <div className='title'>
        <p>{title}</p>
        <div>{legend}</div>
      </div>
      {chart}
      {footer}
    </Card>
  )
}
